import React, { useEffect, useState } from "react";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, UNO_URL } from "../../Server";
import swal from "sweetalert";
import axios from "axios";
import { withRouter, useHistory } from "react-router-dom";
import { HomeIcon } from "../../assets/Icons";
import { connect } from "react-redux";
import HeaderMobileSearch from "../../common/HeaderMobileSearch";
import HeaderMobile from "../../common/HeaderMobile";
import NoDataFound from "../../common/NoDataFound";
import TableSkelton from "../../skeltonloader/TableSkelton";
import UserStripCard from "../../common/UserStripCard";
import GroupUserCard from "../../common/GroupUserCard";
import gailLogo from "../../assets/images/gailLogo.png";
import userImage from "../../assets/images/ui-images/image-rounded.jpg";
import PlaceholderCard from "../../common/PlaceholderCard";
import Search from "../../common/Search";
import SiteDashboard from "../Dashboard/SiteDashboard";

class AlignedWorkflow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allTypes: [],
      showChidComponent: false,
      selectedid: "",
      List: [],
      message: "",
      searchVal: "",
      loading: false,
      activeTab: "dashboard",
      history: [],
      selectedUser: null,
      tempList: [],
      errors: {},
      search: "",
      allWorkFlow: [],
      selectedCheckboxes: [],
      groupList: [],
      groupLoading: true,
      selectedGroupDetail: {},
      stripCardLoading: true,
      groupUsers: [],
    };
  }

  componentDidMount() {
    console.log(this.state.activeTab, "this is active Tab ");
    if (this.props.userDetails?.token) {
      this.init();
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.match.params.id !== prevProps.match.params.id ||
      this.props.userDetails?.token != prevProps?.userDetails?.token
    ) {
      this.setState({ activeTab: "dashboard" });
      this.init();
    }
  }

  search_bar = (e, type = "workflow") => {
    if (type == "workflow") {
      let arr = this.state.tempList;
      if (arr.length === 0) {
        return;
      }
      let findValue = e.target.value.toLowerCase();
      let b = arr.filter((item) => item.workflow_name.toLowerCase().indexOf(findValue) > -1);
      this.setState({ List: b, searchVal: e.target.value });
    } else {
      this.setState({ searchVal: e.target.value });
    }
  };

  closeSearch = () => {
    this.setState({ List: this.state.tempList, searchVal: "" });
  };

  fetch_aligned_workflow = () => {
    var data = {
      user_id: ud.id,
    };
    var _this = this;
    let headers = {
      user_id: ud.id.toString(),
      session_id: ud.session_id.toString(),
      user_type: ud.usertype.toString(),
      main_id: ud.main_id.toString(),
      jwt_token: jwt,
      c_id: ud.c_id.toString(),
    };
    axios
      .post(`${SERVER_IP}/workflowList`, data, { withCredentials: true, headers: headers })
      .then(function (response) {
        if (response.data.error === false) {
          _this.setState({
            List: response.data.workflowList,
            tempList: response.data.workflowList,
            message: "No Record Found.",
          });
        } else {
          auth_response_flow(response.data, (return_response) => {
            if (return_response.error === false && return_response.retry === true) {
              _this.fetch_aligned_workflow();
            }
          });
        }
      })
      .catch(function (error) {
        swal("Something Went Wrong,Please Retry");
      });
  };

  handleTabChange = (tab) => {
    this.setState({
      activeTab: tab,
      history: [],
      selectedUser: null,
    });
  };

  handleUserClick = (user) => {
    this.setState({ selectedUser: user });
  };

  handleBack = () => {
    this.setState({ selectedUser: null });
  };

  fetchSubGroups = async () => {
    try {
      this.setState({ groupLoading: true });
      const groupData = (
        await axios.get(`${UNO_URL}/api/user/group/list/${this.props.match.params?.id}`, {
          headers: {
            Authorization: `Bearer ${this.props.userDetails?.token}`,
          },
        })
      )?.data?.data;

      const formattedData = groupData?.map((ele) => ({
        id: ele?.uuid,
        Name: ele.name,
        editButtonEnable: false,
        cardTypeUser: false,
        Image: ele.avatar,
        groupUsers: ele?.users,
        subGroup: ele?.groups,
      }));
      this.setState({ groupList: formattedData });
    } catch (error) {
      console.error("error in fetching from UNO", error);
    } finally {
      this.setState({ groupLoading: false });
    }
  };

  fetchGroupDetail = async () => {
    try {
      this.setState({ stripCardLoading: true });
      const groupDetails = (
        await axios.get(`${UNO_URL}/api/user/group/details/${this.props.match.params?.id}`, {
          headers: {
            Authorization: `Bearer ${this.props.userDetails?.token}`,
          },
        })
      )?.data?.data;
      this.setState({ selectedGroupDetail: groupDetails });
    } catch (error) {
      console.error("error in fetching from UNO", error);
    } finally {
      this.setState({ stripCardLoading: false });
    }
  };

  fetchGroupUsers = async () => {
    try {
      this.setState({ groupLoading: true });
      const users = (
        await axios.get(`${UNO_URL}/api/user/list/${this.props.match.params?.id}`, {
          headers: {
            Authorization: `Bearer ${this.props.userDetails?.token}`,
          },
        })
      )?.data?.data;
      const formattedData = users?.map((ele) => ({
        uuid: ele?.uuid,
        name: ele?.name,
        email: ele?.email,
        designation: ele?.designation,
        uid: ele?.uid,
        avatar: ele?.avatar,
        groupId: this.props.match.params?.id,
      }));
      this.setState({ groupUsers: formattedData });
    } catch (error) {
      console.error("error in fetching from UNO", error);
    }
  };

  handleGroupClick = (group) => {
    this.props.history.push(`/team/dashboard/${group.id}`);
  };

  handleBack = () => {
    if (this.state.selectedUser) {
      this.setState({ selectedUser: null });
    } else {
      this.props.history.goBack();
    }
  };

  init() {
    this.fetch_aligned_workflow();
    this.fetchGroupDetail();
    this.fetchSubGroups();
    this.fetchGroupUsers();
  }

  render() {
    const { user } = this.props;
    const { isMobile } = user;
    const {
      errors,
      search,
      allWorkFlow,
      selectedCheckboxes,
      loading,
      selectedUser,
      activeTab,
      searchVal,
      List,
      message,
      groupList,
      groupLoading,
      selectedGroupDetail,
      stripCardLoading,
      groupUsers,
    } = this.state;

    const { id } = this.props.match.params;
    const { userDetails } = this.props;
    const myGroupId = userDetails?.user?.group?.uuid;

    return (
      // <div className="h-100">
      <>
        {isMobile && <HeaderMobile />}
        <div className="xp-breadcrumbbar xp-heading">
          <UserStripCard
            details={selectedUser || selectedGroupDetail}
            type={selectedUser ? "User" : "Group"}
            loading={stripCardLoading}
            handleBack={this.handleBack}
            hideBackBtn={myGroupId == id && !selectedUser}
          />
        </div>

        {selectedUser ? (
          <UserWorkflowList selectedUser={selectedUser} />
        ) : (
          <div className="xp-contentbar p-30 pb-0 user-group-content">
            <div className="row h-100">
              <div className="col-lg-12 h-100">
                <div className="dv-center space-between assignedmaintab">
                  <div className="customtab">
                    <ul className="nav-tabs">
                      <li
                        className={activeTab === "dashboard" ? "active" : ""}
                        onClick={() => this.handleTabChange("dashboard")}
                      >
                        Dashboard
                      </li>
                      <li
                        className={activeTab === "group" ? "active" : ""}
                        onClick={() => this.handleTabChange("group")}
                      >
                        Groups {!stripCardLoading && `(${selectedGroupDetail?._count?.children})`}
                      </li>
                      <li className={activeTab === "user" ? "active" : ""} onClick={() => this.handleTabChange("user")}>
                        Users {!stripCardLoading && `(${selectedGroupDetail?._count?.users})`}
                      </li>
                    </ul>
                  </div>

                  {this.state.activeTab !== "dashboard" && (
                    <div className="searchWrapper pb-1">
                      <Search
                        onChange={(e) => this.search_bar(e, "user")}
                        value={searchVal}
                        placeholder={selectedUser ? "Search Workflow" : "Search"}
                      />
                    </div>
                  )}
                </div>
                {activeTab === "dashboard" && (
                  <div className="assignedtabcontent">
                    <SiteDashboard groupId={this.props.match.params?.id} />
                  </div>
                )}
                {activeTab === "group" && (
                  <div className="assignedtabcontent">
                    {groupLoading ? (
                      <div className="sim-list">
                        <PlaceholderCard count={4} />
                      </div>
                    ) : groupList?.filter((e) => e?.Name?.toLowerCase()?.includes(searchVal?.toLowerCase())).length >
                      0 ? (
                      <div className="sim-list">
                        {groupList
                          ?.filter((e) => e?.Name?.toLowerCase()?.includes(searchVal?.toLowerCase()))
                          ?.map((group) => (
                            <GroupUserCard
                              key={group?.id}
                              Image={group.Image}
                              Name={group.Name}
                              groupUsers={group.groupUsers}
                              subGroup={group?.subGroup}
                              cardTypeUser={false}
                              editButtonEnable={false}
                              isActive={true}
                              onClick={() => this.handleGroupClick(group)}
                            />
                          ))}
                      </div>
                    ) : (
                      <NoDataFound headText="No Groups Found." />
                    )}
                    {/* {!groupLoading &&
                    groupList?.filter((e) => e?.Name?.toLowerCase()?.includes(searchVal?.toLowerCase())).length ===
                      0 && <NoDataFound headText={message} />} */}
                  </div>
                )}

                {activeTab === "user" && (
                  <>
                    <div className="assignedtabcontent">
                      {groupLoading ? (
                        <div className="sim-list">
                          <PlaceholderCard count={4} />
                        </div>
                      ) : groupUsers?.filter((e) => e?.name?.toLowerCase()?.includes(searchVal?.toLowerCase())).length >
                        0 ? (
                        <div className="sim-list">
                          {groupUsers
                            ?.filter((e) => e?.name?.toLowerCase()?.includes(searchVal?.toLowerCase()))
                            ?.map((user) => (
                              <GroupUserCard
                                key={user.uuid}
                                Name={user.name}
                                Image={user.avatar}
                                userMail={user.email}
                                userDes={user.designation}
                                user_id={user.uid}
                                cardTypeUser={true}
                                editButtonEnable={false}
                                isActive={true}
                                mailIcon={true}
                                onClick={() => this.handleUserClick(user)}
                              />
                            ))}
                        </div>
                      ) : (
                        <NoDataFound headText="No Users Found." />
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </>
      // </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.userData,
  userDetails: state.userData.userDetails,
});

export default withRouter(connect(mapStateToProps)(AlignedWorkflow));

const UserWorkflowList = ({ selectedUser }) => {
  const [loading, setLoading] = useState(false);
  const [workflowList, setWorkflowList] = useState([]);
  const history = useHistory();

  const handleGetUserWorkflows = async (uuid) => {
    setWorkflowList([]);
    setLoading(true);
    try {
      let headers = {
        user_id: ud.id.toString(),
        session_id: ud.session_id.toString(),
        user_type: ud.usertype.toString(),
        main_id: ud.main_id.toString(),
        jwt_token: jwt,
        c_id: ud.c_id.toString(),
      };

      let bodyData = {
        userId: uuid,
        groupId: selectedUser.groupId,
      };

      let { data } = await axios.post(`${SERVER_IP}/user/assign/workflow/list`, bodyData, {
        withCredentials: true,
        headers: headers,
      });
      setWorkflowList(data.workflowList);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickSeeSession = (list) => {
    sessionStorage.setItem("report_info_workflow", JSON.stringify(list));
    console.log(selectedUser)
    sessionStorage.setItem("report_info_workflow_user", JSON.stringify(selectedUser));
    history.push("/create/alignedworkflowsession");
  };

  useEffect(() => {
    handleGetUserWorkflows(selectedUser.uuid);
  }, [selectedUser]);

  return (
    <>
      <div className="xp-contentbar p-30 py-0 user-group-content">
        <div className="row h-100">
          <div className="col-lg-12 h-100">
            <div className="assignedtabcontent bg-white mt-3 p-4">
              <div className="table-responsive">
                <h4 className="pb-4">{selectedUser.name}'s Workflows</h4>
                <table className="table table-striped table-bordered mcqlist-taable">
                  <thead>
                    <tr>
                      <th className="text-center">S.N.</th>
                      <th className="text-left" style={{ width: "20rem" }}>
                        Name
                      </th>
                      <th className="text-left">Description</th>
                      <th className="text-center" style={{ width: "10rem" }}>
                        Published On
                      </th>
                      <th className="text-center" style={{ width: "8rem" }}>
                        On Going
                      </th>
                      <th className="text-center">Completed</th>
                      <th className="text-center" style={{ width: "8rem" }}>
                        Session
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <TableSkelton rowCount={3} colCount={7} />
                    ) : workflowList.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center message-no-record">
                          <NoDataFound headText="No Data Found" />
                        </td>
                      </tr>
                    ) : (
                      workflowList.map((list, index) => (
                        <tr key={index}>
                          <td className="text-center">{index + 1}</td>
                          <td className="text-left">{list.workflow_name}</td>
                          <td className="text-left">{list.workflow_description}</td>
                          <td className="text-center">{list.workflow_publishdate}</td>
                          <td className="text-center">
                            <span>
                              <strong>{list.workflow_total_ongoing == null ? 0 : list.workflow_total_ongoing} </strong>
                            </span>
                          </td>
                          <td className="text-center">
                            <span>
                              <strong>
                                {list.workflow_total_completed == null ? 0 : list.workflow_total_completed}{" "}
                              </strong>
                            </span>
                          </td>
                          <td className="text-center">
                            <div
                              className="tabledit-toolbar btn-toolbar"
                              style={{ margin: "0 auto", display: "block" }}
                            >
                              <div className="btn-group btn-group-sm">
                                <button
                                  type="button"
                                  onClick={() => handleClickSeeSession(list)}
                                  className="btn text-blue"
                                >
                                  See Session
                                </button>
                              </div>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
